var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFaqIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7149 12.7129C10.6775 14.7506 7.6605 15.1908 5.1916 14.049C4.82712 13.9023 4.52831 13.7837 4.24423 13.7837C3.45298 13.7884 2.46809 14.5556 1.95622 14.0443C1.44435 13.5324 2.21216 12.5467 2.21216 11.7507C2.21216 11.4666 2.09826 11.1731 1.95153 10.8079C0.809205 8.33942 1.25006 5.32147 3.28749 3.28448C5.88838 0.682629 10.114 0.682629 12.7149 3.28381C15.3205 5.88968 15.3158 10.1117 12.7149 12.7129Z",
    stroke: "#2D3958",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6272 8.27474H10.6332H10.6272Z",
    fill: "#2D3958"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6272 8.27474H10.6332",
    stroke: "#2D3958",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.95338 8.27474H7.95938",
    stroke: "#2D3958",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.28125 8.27466H5.28725H5.28125Z",
    fill: "#2D3958"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.28125 8.27466H5.28725",
    stroke: "#2D3958",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaqIcon);
export default __webpack_public_path__ + "static/media/faq-icon.5b8a5e4d535ffd294d158d1d031f0807.svg";
export { ForwardRef as ReactComponent };